export default {
  informacaoVendas: `Informação sobre as vendas`,
  distribuicaoVendas: `Distribuição das vendas`,
  adquirentesCadastradas: `Adquirentes cadastradas`
};
